module.exports = __webpack_public_path__ + "media/interview3.764a5c89.mp3";